window.addEventListener('load', (e) => {
  document.querySelectorAll('link[data-late-prefetch]').forEach((link) => {
    const exSrc = link.getAttribute('data-late-prefetch')
    link.setAttribute('rel', "prefetch")
    link.setAttribute('href', exSrc)
    link.setAttribute('data-late-prefetch', '')
  })
})
